import React from 'react';
import { useSelector, useDispatch } from "react-redux";
import {
    getSubscriptionConstraintSagaAction,
    removeSubscriptionConstraintSagaAction
} from "../../redux/sagaActions";

const SubscriptionConstraints = () => {
    const dispatch = useDispatch();
    const subscription_constraints = useSelector(state => state.subscription_constraints);

    return (
        <div className="settings">
            {
                subscription_constraints.map(elem => {
                    // Убираем элемент «Нет ограничений»
                    if (elem.name === 'Нет ограничений') return;

                    return (
                        <div className="setting" key={ elem.id }>
                            <div className="controls">
                                <i className="control control--edit" onClick={ () => {
                                    dispatch(getSubscriptionConstraintSagaAction({ id: elem.id }));
                                } } />
                                {/*<i className="control control--move" />*/}
                                <i className="control control--remove" onClick={ () => {
                                    if (window.confirm('Вы действительно хотите удалить ограничение?')) {
                                        dispatch(removeSubscriptionConstraintSagaAction({ id: elem.id }));
                                    }
                                } } />
                            </div>
                            <div className="setting__caption">{ elem.name }</div>
                        </div>
                    )
                })
            }
        </div>
    );
};

export default SubscriptionConstraints;